export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kunsthandwerk01-de.1eb4e264.png";